<h1 mat-dialog-title>Contrôle des accès</h1>
<mat-dialog-content>
    <app-item-access-table [item]="item" edit="true"></app-item-access-table>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>